import { createSlice } from '@reduxjs/toolkit';

export type LoaderState = {
  isLoading: boolean;
};

const initialState: LoaderState = {
  isLoading: false
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader: state => {
      // eslint-disable-next-line no-param-reassign
      state.isLoading = true;
    },
    hideLoader: state => {
      // eslint-disable-next-line no-param-reassign
      state.isLoading = false;
    },
    resetLoader: state => initialState
  }
});

export const loaderReducer = loaderSlice.reducer;
export const loaderActions = {
  ...loaderSlice.actions
};
